import { prop, compose, always, identity, ifElse, or, converge } from 'ramda';

import Experiment from 'app/analytics/helpers/Experiment';
import { getCouponCampaignId, getOfferId } from 'app/router/selectors';

const deltaConfig = prop('deltaConfig');

const mainSetup = compose(prop('mainSetup'), deltaConfig);

const experimentEventProperties = compose(
  ifElse(identity, Experiment, always({})),
  prop('experimentEventProperties'),
  mainSetup,
);

const isCampaign = converge(or, [getCouponCampaignId, getOfferId]);

const campaignReferrer = compose(prop('campaignReferrer'), mainSetup);

export { deltaConfig, campaignReferrer, experimentEventProperties, isCampaign };
